import { Checkbox } from 'antd';
import React from 'react';
import ReactMarkdownWithHtml from 'react-markdown/with-html';

const stringInsert = (originalString, index, insertString) => {
    if (index > 0) {
        return originalString.substring(0, index) + insertString + originalString.substr(index);
    }
    return originalString + insertString;
}

const Attest = props => {
    const { def, data, value, onChange } = props;
    const chk = data === 'True';
    var markdown = def.markdown;

    if (markdown) {
        const re = new RegExp(/\u2022\s/, 'g'); //matches the • character that has a white space after it
        const matches = [...markdown.matchAll(re)];
        if (matches.length > 0) {
            matches.reverse().forEach(match => {
                markdown = stringInsert(markdown, match.index, '\n');
            })
        }
    }

    return <div style={{ display: 'flex', flexDirection: 'row' }} data-input={'attestinput_de'}>
        <Checkbox
            key={`${def.dataKey}_${value}_radio`}
            name={def.dataKey}
            checked={chk}
            style={{ paddingTop: '3px' }}
            onChange={ev => onChange(def.dataKey, ev.target.checked)} //uses special _toggleAttestation method in FormEngine.js
        />
        <div style={{ display: 'block', marginLeft: "8px" }}>
            <ReactMarkdownWithHtml allowDangerousHtml>{markdown}</ReactMarkdownWithHtml>
        </div>
    </div>

}

export default Attest;
